module.exports = __webpack_public_path__ + "images/emoji/bento.45c402971f650ba6a9d0.png";